import React from 'react';
import PropTypes from 'prop-types';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ConfigureSocialMediaDialog = ({ open, onClose, onProceed, intl, classes }) => {
	return (
		<Dialog
			aria-labelledby="Configure Social Media"
			// open={dialogOpen}
			BackdropProps={{ invisible: false }}
			maxWidth="xs"
			fullWidth
			open={open}
		>
			<DialogTitle className={classes.title}>
				{'Configure Social Media'}
				<IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers>
				<p>
					{intl.formatMessage({
						id: 'pages.MediaFiles.components.ShareToSocialMedia.ConfigSocialMediaLine1',
					})}
				</p>
				<p>
					{intl.formatMessage({
						id: 'pages.MediaFiles.components.ShareToSocialMedia.ConfigSocialMediaLine2',
					})}
				</p>
				<p>
					{intl.formatMessage({
						id: 'pages.MediaFiles.components.ShareToSocialMedia.ConfigSocialMediaLine3',
					})}
				</p>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="primary">
					Cancel
				</Button>
				<Button onClick={onProceed} color="primary">
					Go Ahead
				</Button>
			</DialogActions>
		</Dialog>
	);
};

// export default ConfigureSocialMediaDialog;
ConfigureSocialMediaDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onProceed: PropTypes.func.isRequired,
	intl: PropTypes.object.isRequired,
	classes: PropTypes.object,
};

export default ConfigureSocialMediaDialog;
